// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"038b0b7b","551":"388f85b1","842":"bc575339"}[chunkId] + ".chunk.js";
};